import _defineProperty from "/builds/webservices/sites/campaigns-cigna-com/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "/builds/webservices/sites/campaigns-cigna-com/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { is } from './type'; // Turns foo=bar&fizz=buzz to {foo: 'bar', fizz: 'buzz'}

export var getParams = function getParams(search) {
  return (search || location.search).replace(/^\?/, '').split('&').filter(Boolean).map(function (param) {
    return param.includes('=') ? param.split('=') : [param, true];
  }).reduce(function (result, input) {
    var _input = _slicedToArray(input, 2),
        key = _input[0],
        val = _input[1];

    return Object.assign(result, _defineProperty({}, key, val === true ? val : decodeURIComponent(val)));
  }, {});
}; // from https://www.rrssb.ml

export var encodeString = function encodeString(text) {
  // Recursively decode string first to ensure we aren't double encoding.
  if (text) {
    if (is(String, text) && text.match(/%[0-9a-f]{2}/i)) {
      text = decodeURIComponent(text);
      encodeString(text);
    } else {
      return encodeURIComponent(text);
    }
  }
};
export var buildParams = function buildParams(query) {
  return Object.keys(query).map(function (param) {
    var value = query[param];
    var queryValue = is(Array, value) ? value.map(function (v) {
      return encodeString(v);
    }).join(',') : encodeString(value);
    return "".concat(param, "=").concat(queryValue);
  }).join('&');
};
export var updateQueryString = function updateQueryString(newParams, url) {
  url = url || location;
  var searchParams = url.search ? getParams(url.search) : {};
  var params = Object.assign({}, searchParams, newParams);
  return buildParams(params);
};